export default "__VITE_ASSET__2d8873b8__"